<template>
    <v-row dense>
        <v-col
                v-for="(option, optionKey) in field.options"
                :key="option.id"
                dense
                cols="6"
                lg="4"
                class="ma-0 py-0">
            <v-checkbox
                    v-if="field.options && field.options.length && option.is_visible"
                    v-model="value[optionKey]"
                    dense
                    class="ma-0 mt-0 py-0 field-option-checkbox"
                    :label="option.value"
                    :messages="option.notice || []"
                    :value="option.id"
                    :error="errorState"
                    @change="updateCheckbox(optionKey, option)" />
        </v-col>
        <v-col
                dense
                cols="12"
                class="mt-0 pt-0">
            <v-messages
                    v-if="errorState"
                    color="error"
                    :value="[error]" />
        </v-col>
    </v-row>
</template>
<style>
.field-option-checkbox .v-label {
    word-break: break-word;
    overflow-wrap: break-word;
    word-wrap: break-word;
    -webkit-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
}
</style>
<script>
    import Value from "../../../../../models/value.model";
    import Field from "@/models/field.model";

    export default {
        name: "FieldCheckboxComponent",
        props: {
            field: {type: Object, default: () => new Field()},
        },
        data() {
            return {
                value: {},
                error: null,
            }
        },
        computed: {
            errorState() {
                return !!this.error;
            }
        },
        watch: {
            value: {
                deep: true,
                handler(oldVal) {
                    if (oldVal instanceof Value)  {
                        this.getValue().then((value) => {
                            this.$emit('updateValue', value);
                        })
                    }
                }
            }
        },
        mounted() {
            this.value = this.field.value.value;
        },
        methods: {
            /**
             *
             * @returns {Value}
             */
            async getValue() {
                const value = new Value({
                    value: this.value,
                    isValid: true
                });

                if (!this.field.is_optional && value.isEmpty) {
                    this.error = 'Mandatory field';
                } else {
                    this.error = null
                }

                if (this.error) {
                    value.isValid = false;
                    value.error = this.error;
                }

                return value;
            },
            isEmpty() {
                return Object.values(this.value).every(v => v);
            },
            isValid() {
                return true;
            },
            updateCheckbox(optionKey, option) {
                if (this.value[optionKey] === option.id) {
                    Object.entries(this.value).forEach(([selectedOptionKey, selectedOptionId]) => {
                        if (option.id !== selectedOptionId) {
                            if (option.is_exclusive) {
                                this.value[selectedOptionKey] = null;
                            } else {
                                if (this.field.options[selectedOptionKey].is_exclusive) {
                                    this.value[selectedOptionKey] = null;
                                }
                            }
                        }
                    })
                }
                this.getValue().then((value) => {
                    this.$emit('updateValue', value);
                })
            },
        }
    }
</script>